import { printPage } from './initPrint';

// Tools of the article pages (templates/articles/parts): table of contents, copy link, print.
// No third-party scripts and no requests: everything happens in the browser of the visitor.

// only section headings (h2); panels and boxes inside the text have h2 headings of their own that do not belong in the list
const HEADING_SELECTOR = 'h2:not(.article-panel__title):not(.article-proscons__title)';

function slugify(text) {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

function buildToc() {
    const toc = document.querySelector('[data-article-toc]');
    const body = document.querySelector('[data-article-body]');
    if (!toc || !body) {
        return;
    }

    const headings = Array.from(body.querySelectorAll(HEADING_SELECTOR)).filter((heading) => heading.textContent.trim() !== '');
    if (headings.length < 2) {
        return;
    }

    const list = toc.querySelector('.article-toc__list');
    const used = new Set();
    const links = [];

    headings.forEach((heading) => {
        let id = heading.id || slugify(heading.textContent) || 'section';
        for (let i = 2; used.has(id); i++) {
            id = `${slugify(heading.textContent) || 'section'}-${i}`;
        }
        used.add(id);
        heading.id = id;

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        list.appendChild(item);
        links.push({ heading, link });
    });

    toc.hidden = false;

    // marks the link of the heading that was passed last
    if ('IntersectionObserver' in window) {
        const setCurrent = (current) => links.forEach(({ link, heading }) => {
            if (heading === current) {
                link.setAttribute('aria-current', 'true');
            } else {
                link.removeAttribute('aria-current');
            }
        });
        const observer = new IntersectionObserver((entries) => {
            entries.filter((entry) => entry.isIntersecting).forEach((entry) => setCurrent(entry.target));
        }, { rootMargin: '-15% 0px -70% 0px' });
        headings.forEach((heading) => observer.observe(heading));
    }
}

function initCopyLink() {
    document.querySelectorAll('[data-article-copy]').forEach((button) => {
        const label = button.querySelector('span');
        const original = label ? label.textContent : '';

        button.addEventListener('click', async () => {
            try {
                await navigator.clipboard.writeText(button.dataset.articleCopy);
            } catch (e) {
                // no clipboard permission (e.g. http): select the address for the visitor instead
                window.prompt('', button.dataset.articleCopy);
                return;
            }
            if (label) {
                label.textContent = button.dataset.copied || original;
                window.setTimeout(() => {
                    label.textContent = original;
                }, 2000);
            }
        });
    });
}

function initPrint() {
    document.querySelectorAll('[data-article-print]').forEach((button) => {
        button.addEventListener('click', () => printPage());
    });
}

export default function initArticleTools() {
    if (!document.querySelector('.article')) {
        return;
    }

    buildToc();
    initCopyLink();
    initPrint();
}
